/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candid_Watery_Skate_FondInputs */

const fr_candid_watery_skate_fond = /** @type {(inputs: Candid_Watery_Skate_FondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

/**

* @param {Candid_Watery_Skate_FondInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const candid_watery_skate_fond = /** @type {((inputs?: Candid_Watery_Skate_FondInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candid_Watery_Skate_FondInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_candid_watery_skate_fond(inputs)
});